/** Settings > Business > Setup emails. */
export const SETUP_EMAILS_PATH = '/admin/settings/setup-emails';
/** The token's shape (backend contract, 2026-10-08): 64 hex, a dash, 32 hex. Anything else never reaches an API path (and makes no request). */
export const TOKEN_SHAPE = /^[0-9a-f]{64}-[0-9a-f]{32}$/i;

/** The unsubscribe link in every setup email: `/u/<token>`. Opened before the app's providers (see App.tsx), like /q and /i. */
export const isUnsubscribePath = (pathname: string): boolean => /^\/u\/[^/]+\/?$/.test(pathname);

/** The token segment of `/u/<token>` (decoded), or null. The caller still checks TOKEN_SHAPE. */
export function parseUnsubscribePath(pathname: string): string | null {
  const m = pathname.match(/^\/u\/([^/]+)\/?$/);
  if (!m) return null;
  try {
    return decodeURIComponent(m[1]);
  } catch {
    return null;
  }
}
